import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import AppNavbar from "./AppNavbar";
import AppSidebar from "./AppSidebar";

const titlePrefix = window.__env.APP_TITLE_PREFIX || "Get Move - ";

export default function AppLayout() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <main className="app-root">
      <Helmet titleTemplate={`${titlePrefix}%s`}></Helmet>
      {pathname === "/login" ? (
        <Outlet />
      ) : (
        <>
          <AppNavbar className="background-primary" showSidebar={handleShow} />
          <AppSidebar show={show} handleClose={handleClose} />
          <div className="full-viewport">
            <Outlet />
          </div>
        </>
      )}
    </main>
  );
}
